import { render, staticRenderFns } from "./ExpenseSection.vue?vue&type=template&id=aceb3a6a&scoped=true"
import script from "./ExpenseSection.vue?vue&type=script&lang=js"
export * from "./ExpenseSection.vue?vue&type=script&lang=js"
import style0 from "./ExpenseSection.vue?vue&type=style&index=0&id=aceb3a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb3a6a",
  null
  
)

export default component.exports